export default [
  {
    itemType: 'group',
    colCount: 1,
    items: [
      {
        dataField: 'prazo_descricao',
        label: { text: 'Descrição' },
        validationRules: [{
          type: 'required',
          message: 'Descrição é obrigatório'
        }]
      },
      {
        dataField: 'prazo_formula',
        label: { text: 'Fórmula' },
        validationRules: [{
          type: 'required',
          message: 'Fórmula é obrigatório'
        }]
      },
      {
        dataField: 'qtde_parc_prazo',
        label: { text: 'Qtde Parcelas' },
        editorType: 'dxNumberBox',
        editorOptions: {
          format: '#0'
        },
        validationRules: [{
          type: 'required',
          message: 'Parcelas Fórmula é obrigatório'
        }]
      },
      {
        dataField: 'privilegio_por_cadastro',
        label: { text: 'Privilégio' },
        editorType: 'dxSelectBox',
        editorOptions: {
          items: [
            { value: 'S', label: 'Sim' },
            { value: 'N', label: 'Não' }
          ],
          displayExpr: 'label',
          valueExpr: 'value'
        }
      },
      {
        dataField: 'sincronizado',
        label: { text: 'Sincronizado' },
        editorType: 'dxSelectBox',
        editorOptions: {
          items: [
            { value: 'S', label: 'Sim' },
            { value: 'N', label: 'Não' }
          ],
          displayExpr: 'label',
          valueExpr: 'value'
        }
      }
    ]
  }
]
